/**
 * Custom hook for tracking unread messages count
 */

import { useState, useEffect } from 'react';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import messagingService from '../services/messagingService';

/**
 * Custom hook to get and subscribe to unread messages count
 * 
 * @returns {number} The total unread messages count
 */
const useUnreadMessages = () => {
  const [unreadCount, setUnreadCount] = useState(0);
  const [user, setUser] = useState(null);

  // Listen for auth state changes
  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
    });
    
    return () => unsubscribe();
  }, []);

  // Subscribe to unread count when user changes
  useEffect(() => {
    if (!user) {
      setUnreadCount(0);
      return;
    }
    
    // Get initial count
    messagingService.getTotalUnreadCount()
      .then(count => setUnreadCount(count))
      .catch(err => console.error('Error getting unread count:', err));
    
    // Subscribe to real-time updates
    const unsubscribe = messagingService.subscribeToUnreadCount((count) => {
      setUnreadCount(count);
    });
    
    return () => unsubscribe();
  }, [user]);

  return unreadCount;
};

export default useUnreadMessages;